import Service from './Service';
import http from './http';

class DashboardService extends Service {
  constructor() {
    super('/v1.1/filial/dashboard');
  }

  getDashboard(filialId) {
    return http.get(`${this.baseUrl}/${filialId}`);
  }

  patchConsistencia(filialId, imovelId) {
    return http.patch(`${this.baseUrl}/${filialId}/ativo/imovel/${imovelId}`);
  }

  generatePeriodCode(ativoId) {
    return http.post(`/v1.1/filial/imovel/${ativoId}/enviar-codigo`);
  }
}

const dashboardService = new DashboardService();
export default dashboardService;



// WEBPACK FOOTER //
// ./src/services/DashboardService.js